// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7Tukj","left":"styles_left__3At7_"};